%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: DragonAttack2
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 0}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 7eecff82092cb4b3a9bca0daf1f9f480, type: 3}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 8300000, guid: e051d1f79ef314bcb8d44c40a761bf22, type: 3}
  afterChannelSoundDelay: 500
  animation: 19
  animationVariation: 3
  castDelay: 0
  animationSpeed: 1
  animationDuration: 2
  skipCooldownOnChannel: 0
  spellName: Tail Swing
  description: Deal damage to anyone behind the dragon.
  icon: {fileID: 2800000, guid: 8f2b7cddd344aab4ebce90b33d02ce42, type: 3}
  usableBy: 1c000000
  cooldown: 6
  castTime: 0
  isCastInterruptible: 0
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 1
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100101
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: 5b4dddf07c41e6a4f99cc739ebce0f62, type: 3}
